import { useState, useEffect } from "react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getApp } from "firebase/app";

const useTitulosSeccion = (seccion = "0km") => {
  const [titulos, setTitulos] = useState({ tituloPrincipal: "", items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const db = getFirestore(getApp());
        const docRef = doc(db, "titulosSeccion", seccion);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setTitulos({
            tituloPrincipal: data.tituloPrincipal || "OKM",
            items: data.items || [],
          });
        } else {
          setTitulos({ tituloPrincipal: "OKM", items: [] });
        }
      } catch (e) {
        setTitulos({ tituloPrincipal: "OKM", items: [] });
      }
      setLoading(false);
    };
    fetchData();
  }, [seccion]);

  return { titulos, loading };
};

export default useTitulosSeccion;
